import { render, staticRenderFns } from "./shopDataInfo.vue?vue&type=template&id=05ecbf7b&"
import script from "./shopDataInfo.vue?vue&type=script&lang=js&"
export * from "./shopDataInfo.vue?vue&type=script&lang=js&"
import style0 from "./shopDataInfo.vue?vue&type=style&index=0&id=05ecbf7b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports